import moment from "moment";
import { Dialog } from "construct-ui";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import CodeMasterModel from "../../models/common/code-master.model";
import PopupManagementModel from "../../models/pop-up-management/pop-up-management.model";
import ViewBase from "../view-base.view";
import AddPopupDialog from "./add-popup.dialog";
import loginModel from "../../models/login.model"
import { formats as FORMATS, codeMasterType } from "../../config/constants";

/**
 * Pop-up Management View For WEB Popup
 * 
 * View page that displays all customized pop-up notice
 * 
 * @author Molly Liu
 */

export default function PopupManagementView() {
  ViewBase.call(this);
  const DEFAULT_FILTERS = {
    division: {},
    status: {},
    title: '',
    writer: '',
    periodFrom: moment().subtract(1, 'month').format(FORMATS.dateFormat),
    periodTo: moment().format(FORMATS.dateFormat),
  };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let currentSearchParams = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let data = [];
  let divisions = [];
  let statuses = [];
  let uploadedFiles = [];
  let isAddPopupOpen = false;
  let popupId = '';

  const toQueryParams = (params) => {
    return Object.assign(
      {
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
        division: params.division?.code || '',
        status: params.status?.code || '',
        title: params.title,
        writer: params.writer,
        periodFrom: moment(params.periodFrom).format(FORMATS.apiDateFormat),
        periodTo: moment(params.periodTo).format(FORMATS.apiDateFormat),
      },
    );
  };

  const handleFormSubmit = (e) => {
    if (!this.validateForm(e)) return false;

    pagination = structuredClone(DEFAULT_PAGINATION);
    currentSearchParams = structuredClone(filters);
    getData();
  }

  const getData = () => {
    this.showLoading();
    PopupManagementModel.getPopupList(toQueryParams(currentSearchParams))
      .then((result) => {
        if (result.data) {
          data = result.data;
          pagination.pageIndex = result.pageIndex;
          pagination.pageSize = result.pageSize;
          pagination.totalItems = result.total;
        }
      })
      .catch((error) => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const getStatuses = () => {
    CodeMasterModel.getByCategoryV2({ category: 'PopupManagement' })
      .then((result) => {
        statuses = result
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getDivisions = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    CodeMasterModel.searchByCategoryV2(codeMasterType.divisionGroup, params)
      .then(result => {
        divisions = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    pagination = structuredClone(DEFAULT_PAGINATION);
  }

  const onSaveComplete = (result) => {
    isAddPopupOpen = false;
    getData();
  }

  const openAddPopupDialog = (id) => {
    popupId = id;
    isAddPopupOpen = true;
  }

  const closeAddPopupDialog = () => {
    isAddPopupOpen = false;
  }

  return {
    oninit: () => {
      getStatuses();
      getDivisions();
      currentSearchParams = structuredClone(filters);
      const params = toQueryParams(currentSearchParams);
      getData(params);
    },
    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m('.card-body',
            m('form.needs-validation[novalidate].row.g-2', { onsubmit: handleFormSubmit },
              m(".col-md-3.col-lg-3.position-relative",
                m('label.form-label[for="division"]',
                  this.getText("LT00000233", "Division")
                ),
                m(SingleSelectComponent, {
                  id: "division",
                  items: divisions,
                  allowEmpty: true,
                  filterable: false,
                  selectedItem: filters.division,
                  onSelect: (selectedItem) => {
                    filters.division = selectedItem
                  }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for=status]', this.getText("LT00000015", "Status")),
                m(SingleSelectComponent, {
                  id: 'status',
                  items: statuses,
                  allowEmpty: true,
                  selectedItem: filters.status,
                  onSelect: (selectedItem) => {
                    filters.status = selectedItem
                  }
                }),
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="modelCodeInput"]', this.getText('LT00000037', 'Title')),
                m('input#modelCodeInput', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText('LT00000037', 'Title'),
                  type: 'text',
                  value: filters.title,
                  onchange: (e) => { filters.title = e.target.value }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="descriptionInput"]', this.getText('LT00001188', 'Writer')),
                m('input#descriptionInput', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText('LT00001188', 'Writer'),
                  type: 'text',
                  value: filters.writer,
                  onchange: (e) => { filters.writer = e.target.value }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="datePicker"]', this.getText('LT00000150', 'Period')),
                m(DatePickerComponent, {
                  id: 'datePicker',
                  class: 'form-control',
                  placeholder: this.getText('LT00000895', 'Time Range'),
                  isRange: true,
                  dateStart: filters.periodFrom,
                  dateEnd: filters.periodTo,
                  onselect: (event) => {
                    filters.periodFrom = event.detail.start;
                    filters.periodTo = event.detail.end;
                  }
                })
              ),
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary[type="submit"]', this.getText("LT00000001", "Search")),
                m('button.btn.btn-white',
                  {
                    onclick: () => {
                      clearFilter();
                    }
                  },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.row.g-2',
              m('.col-12.d-flex.justify-content-end',
                m('button.btn.btn-primary', {
                  onclick: () => { openAddPopupDialog('') }
                },
                  m('i.bi.bi-plus-circle'),
                  this.getText('WM090206', 'Registration'))
              ),
              m('.col-12',
                m('.table-responsive',
                  m('table.table',
                    m('thead',
                      m('tr.align-middle.center',
                        m('th', this.getText('LT00000721', 'No.')),
                        m('th', this.getText('LT00000037', 'Title')),
                        m('th', this.getText('LT00001188', 'Writer')),
                        m('th', this.getText('LT00000150', 'Period')),
                        m('th', this.getText('LT00001189', 'File')),
                        m('th', this.getText('LT00000041', 'Create Date')),
                        m('th', this.getText('LT00000781', 'Status')),
                      )
                    ),
                    m('tbody',
                      data.length == 0 &&
                      m("tr", { "class": "align-middle" },
                        m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                      ),
                      data.map((item, index) => {
                        return m('tr.align-middle.center',
                          m('td', m('span', item.popupId)),
                          m("td", { style: "width:40%;white-space: break-spaces;" }, m('button.btn.btn-link.py-0', { onclick: () => { openAddPopupDialog(item.popupId); } }, item.title)),
                          m('td', m('span', item.createUserId)),
                          m('td', m('span', `${moment(item.periodFrom).format(FORMATS.ISO_DATE_FORMAT)} - ${moment(item.periodTo).format(FORMATS.ISO_DATE_FORMAT)}`)),
                          m('td', m('span', item.hasFile ? "Y" : "N")),
                          m('td', m('span', item.createDate)),
                          m('td', m(`span.badge.rounded-pill${item.useYN == "Active" ? '.green-bg-status' : '.danger-bg-status'}`, item.useYN === "Active" ? this.getText('LT00000025', 'Active') : this.getText('', 'Inactive'))),

                        );
                      })
                    )
                  )
                )
              )
            ),
            m('.col-12', m(paginationComponent,
              {
                currentPage: pagination.pageIndex,
                pageSize: pagination.pageSize,
                totalItems: pagination.totalItems,
                onPageChanged: (pageIndex) => {
                  pagination.pageIndex = pageIndex;
                  getData();
                },
                onPageSizeChanged: (_, pageSize) => {
                  pagination.pageIndex = DEFAULT_PAGINATION.pageIndex
                  pagination.pageSize = pageSize;
                  getData();
                }
              }
            ))
          )
        ),
        isAddPopupOpen && m(Dialog, {
          isOpen: isAddPopupOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: closeAddPopupDialog,
          title: popupId ? this.getText("LT00000498", "Update") : this.getText("LT00000058", "Create"),
          content: m(AddPopupDialog, { popupId: popupId, onAddClose: closeAddPopupDialog, uploadedFiles: uploadedFiles, onSaveComplete: onSaveComplete }),
          "class": "cui-dialog-xxl",
        }),
        this.getBaseViews()
      ];
    }
  };
}
